



































































































































































































import { defineComponent, computed, ref, Ref, reactive, watch, onMounted, onUnmounted } from '@vue/composition-api';
import { UserIcon, EditIcon, CloseIcon, ErrorCircleFilledIcon, LinkUnlinkIcon, LinkIcon } from 'tdesign-icons-vue';
import ImageCompressor from 'image-compressor.js';
import { DialogInstance, DialogPlugin, UploadFile } from 'tdesign-vue';

import UserEditDialog from '@/renderer/components/user/components/userConfig/UserEditDialog.vue';
import BaseIcon from '@/renderer/components/common/BaseIcon.vue';
import AgreementJump from '@/renderer/components/Base/Agreement/AgreementJump.vue';
import userConfigHandler, { ShowWitchEditType } from '@/renderer/components/user/compositions/userConfigHandler';
import '@/renderer/assets/images/Icon/svg/wechat-icon.svg';
import '@/renderer/assets/images/Icon/svg/meetting-icon.svg';
import '@/renderer/assets/images/Icon/svg/qqdoc-icon.svg';
import '@/renderer/assets/images/Icon/svg/enterprise.svg';
import '@/renderer/assets/images/Icon/svg/enterprise-en.svg';
import '@/renderer/assets/images/Icon/svg/org-channel-tag-en.svg';
import '@/renderer/assets/images/Icon/svg/org-channel-tag.svg';
import '@/renderer/assets/images/Icon/svg/personal.svg';
import '@/renderer/assets/images/Icon/svg/personal-en.svg';
import '@/renderer/assets/images/Icon/svg/team.svg';
import '@/renderer/assets/images/Icon/svg/team-en.svg';
import '@/renderer/assets/images/Icon/svg/space-info-icon.svg';

import userSetting from '@/renderer/components/user/compositions/userSetting';
import { phoneCompose, getUrlQuery } from '@/renderer/scripts/utils/tools';
import { dispatchRouter } from '@/renderer/scripts/utils/tools/dispatchRouter';
import tips from '@/renderer/scripts/utils/tips';
import i18n, { i18n_t } from '@/locales/i18n';
import useSpaceCenter, { VersionType } from '@/renderer/components/user/compositions/userSpaceHandler';
import headerAdvertHandler from '@/renderer/views/desktop/headbar/components/GeneralHeader/composition/headerAdvertHandler';
import meetingHandler from '@/renderer/components/meeting/meetingHandler';
import ConstantConfig from '@/renderer/scripts/utils/ConstantConfig';
import { CONSTANT_URL } from '@/renderer/scripts/http/index';
import ipc from '@/renderer/scripts/utils/ipc';
import { IpcEvents } from '@/ipc-events';
import { IS_PRIVATE } from '@/common/constant';

export default defineComponent({
  components: {
    UserIcon,
    EditIcon,
    CloseIcon,
    ErrorCircleFilledIcon,
    LinkUnlinkIcon,
    LinkIcon,
    BaseIcon,
    UserEditDialog,
    AgreementJump,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, context) {
    const innerShow = computed({
      get() {
        return props.show;
      },
      set(val) {
        context.emit('update:show', val);
      },
    });
    const store = context.root.$store;

    const renewalMsg = ref('');
    const warningBtn = ref('');
    const isShowEdit = ref(false);
    const showWitchEdit: Ref<ShowWitchEditType> = ref(ShowWitchEditType.none);
    const editingPassword = computed(
      () => showWitchEdit.value === ShowWitchEditType.password || showWitchEdit.value === ShowWitchEditType.space,
    );

    const showSpaceWarning = ref(true);
    const { usedSpace, leftSpace, totalSpace, percentSpace, hasPersonalSpace, isShareSpace, versionType } =
      useSpaceCenter();
    const showRenewSpace = computed(() => {
      const show = ['superAdmin', 'admin'].includes(store.getters.userBaseInfo.role);
      if (show) {
        reporter.report('value_added', { use_time_show: 'personal_setting_fixed_show' });
      }
      return show;
    });
    const progressColor = computed(() => {
      return percentSpace.value > 80 ? { '70%': '#0444D9', '100%': '#ED515D' } : '#0444D9';
    });
    const userNameCanEdit = computed<boolean>(() => {
      return store.getters.allowChangeNickname;
    });
    const userRoleName = computed(() => {
      let name = '';
      if (store.getters.userBaseInfo.isTemporary) {
        name = i18n_t('临时用户');
      } else if (store.getters.userBaseInfo.role === 'superAdmin') {
        name = i18n_t('超级管理员');
      } else if (store.getters.userBaseInfo.role === 'admin') {
        name = i18n_t('系统管理员');
      } else if (store.getters.userBaseInfo.role === 'user') {
        name = i18n_t('普通用户');
      }
      return name;
    });
    const accountTypeIcon = computed(() => {
      let type = i18n.locale === 'zh-CN' ? 'enterprise' : 'enterprise-en';
      if (versionType.value === VersionType.free) {
        type = i18n.locale === 'zh-CN' ? 'org-channel-tag' : 'org-channel-tag-en'; // 免费版,不显示免费版了
      } else if (versionType.value === VersionType.test) {
        type = i18n.locale === 'zh-CN' ? 'org-channel-tag' : 'org-channel-tag-en'; // 体验版
      } else if (versionType.value === VersionType.personal) {
        type = i18n.locale === 'zh-CN' ? 'personal' : 'personal-en'; // 个人版
      } else if (versionType.value === VersionType.team) {
        type = i18n.locale === 'zh-CN' ? 'team' : 'team-en'; // 团队版
      }
      return type;
    });
    const userNickname = computed(() => store.getters.userBaseInfo.nickname);
    const userPhoneNumber = computed(() =>
      phoneCompose(store.getters.userBaseInfo.countryCode, store.getters.userBaseInfo.phoneNumber),
    );

    const expiredTime = computed(() => {
      const time = store.getters.expireTime || '';
      return time.split(' ')[0];
    });
    const avatorVerifyFlag = reactive({
      beyondSize: false,
      wrongFormat: false,
    });
    const avatarMaxSize = ConstantConfig.userAvatarMaxSize;

    const userAvatar = computed(() => {
      const { avatar } = store.getters.userBaseInfo;
      if (!avatar) return '';
      return avatar.includes('http') ? avatar : `${store.getters.protocol}:${avatar}`;
    });
    const userEmail = computed(() => store.getters.userBaseInfo.email);
    // 没有绑定任何第三方应用
    const noBindApps = computed(() => {
      const values = Object.values(store.getters.userBaseInfo.thirdPartyAuthList);
      return !values.some(Boolean);
    });

    const { unbindMeeting, bindMeeting, unbindWechat, unbindSSO } = userSetting();
    const { methods: meetingMethods } = meetingHandler();

    watch(innerShow, newValue => {
      avatorVerifyFlag.beyondSize = false;
      avatorVerifyFlag.wrongFormat = false;
      if (newValue) {
        showWitchEdit.value = ShowWitchEditType.none;
      }
    });

    const { upload, uploading } = userConfigHandler();
    const isEditing = computed(() => {
      const value = showWitchEdit.value !== ShowWitchEditType.none;
      return value;
    });
    // 企业空间剩余容量
    const { tipData, orgAvaPercent, methods: advertMethods } = headerAdvertHandler();
    const showUpSpace = computed(() => {
      const show = orgAvaPercent.value < 20 && showSpaceWarning.value && showRenewSpace.value;
      if (show) {
        advertMethods.showHeaderAdvert('space', undefined, 'setting');
        renewalMsg.value = tipData.renewalMsg;
        warningBtn.value = tipData.warningBtn;
      }
      return show;
    });
    const methods = {
      closeEdit() {
        isShowEdit.value = false;
      },
      switchEditType(type: ShowWitchEditType) {
        showWitchEdit.value = type;
        isShowEdit.value = true;
      },
      async beforeUpload(file: UploadFile): Promise<any> {
        const f = file.raw;
        if (!f) {
          return;
        }
        const msg = i18n_t('仅支持jpg、png、jpeg格式，不超过5MB');
        avatorVerifyFlag.beyondSize = false;
        avatorVerifyFlag.wrongFormat = false;
        const lastIndex = f.name.lastIndexOf('.');
        if (lastIndex < 0) {
          tips.warning(msg);
          setTimeout(() => {
            avatorVerifyFlag.wrongFormat = true;
          }, 50);
          return false;
        }
        const imageType = f.name.slice(lastIndex + 1).toLowerCase();
        if (!f.type.includes('image') || !['png', 'jpg', 'jpeg'].includes(imageType)) {
          tips.warning(msg);
          setTimeout(() => {
            avatorVerifyFlag.wrongFormat = true;
          }, 50);
          return false;
        }
        if (f.size <= 327200) {
          upload(f);
          return true;
        }
        new ImageCompressor(f, {
          quality: 6,
          success(result) {
            const jf = new File([result], f.name, { type: f.type, lastModified: f.lastModified });
            if (jf.size / 1024 > avatarMaxSize) {
              tips.warning(msg);
              setTimeout(() => {
                avatorVerifyFlag.beyondSize = true;
              }, 50);
              return false;
            }
            upload(jf);
            return true;
          },
        });
        return true;
      },
      // 扩容 充值
      openUpSpace(type: number) {
        if (store.getters.isPrivate && type === 0) {
          const dialog: DialogInstance = DialogPlugin.alert({
            theme: 'warning',
            placement: 'center',
            header: i18n_t('温馨提醒'),
            body: i18n_t('请联系管理员进行扩容'),
            width: '400px',
            async onConfirm() {
              if (dialog.hide) {
                dialog.hide();
              }
            },
          });
          return;
        }
        if (store.getters.orgChannel && !store.getters.channelUpdated) {
          dispatchRouter(
            `${CONSTANT_URL.channelBuyUrl}&orgId=${store.getters.orgId}&instanceId=${store.getters.instanceId}`,
          );
        } else {
          // 企业版直接进控制台
          dispatchRouter(CONSTANT_URL.consoleManagementUrl);
        }
        if (type === 0) {
          // 扩容
          reporter.report('value_added', { space_click: 'personal_setting_top_bar' });
        } else {
          // 续费
          reporter.report('value_added', { use_time_click: 'personal_setting_fixed_show' });
        }
      },
      closeSpaceWarning() {
        showSpaceWarning.value = false;
      },
      // 续费
      renewSpace() {
        this.openUpSpace(1);
      },
      handleClientAuth(e: any, url: string) {
        const urlParams = getUrlQuery(url);
        if (urlParams.query?.auth_code && urlParams.query?.meetingAction) {
          meetingMethods.authMeeting(urlParams.query.auth_code, urlParams.query.meetingAction);
        }
      },
    };

    onMounted(() => {
      ipc.on(IpcEvents.HANDLE_MEETING_AUTH, methods.handleClientAuth);
    });
    onUnmounted(() => {
      ipc.off(IpcEvents.HANDLE_MEETING_AUTH, methods.handleClientAuth);
    });

    return {
      isEditing,
      editingPassword,
      innerShow,
      avatarMaxSize,
      showWitchEdit,
      userAvatar,
      userNickname,
      userEmail,
      userPhoneNumber,
      avatorVerifyFlag,
      uploading,
      ...methods,
      noBindApps,
      userRoleName,
      usedSpace,
      leftSpace,
      totalSpace,
      percentSpace,
      hasPersonalSpace,
      isShareSpace,
      expiredTime,
      accountTypeIcon,
      showSpaceWarning,
      showRenewSpace,
      showUpSpace,
      progressColor,
      renewalMsg,
      warningBtn,
      isShowEdit,
      ShowWitchEditType,
      userNameCanEdit,
      unbindMeeting,
      bindMeeting,
      unbindWechat,
      unbindSSO,
    };
  },
});
